class ChatPrizeStatus {
    public username: string = '';
    public pendingResponse: boolean = true;
    public chatPrizeSuccess: boolean = false;
    public responseMessage: string = '';
}

export { ChatPrizeStatus };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/models/chat-prize-status.ts